'use client';

import { Transition } from '@headlessui/react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { ComponentProps } from 'react';

import { MergeVariantProps } from '../cva';
import { useTooltipState } from './context';
import {
    arrowVariants,
    TooltipVariantProps,
    tooltipVariants,
} from './variants';

export type TooltipContentProps = MergeVariantProps<
    ComponentProps<'div'> & TooltipPrimitive.TooltipContentProps,
    TooltipVariantProps
>;

export function TooltipContent({
    children,
    color,
    ...props
}: TooltipContentProps) {
    const { open } = useTooltipState();

    return (
        <TooltipPrimitive.Portal forceMount>
            <Transition show={open} appear>
                <TooltipPrimitive.Content
                    collisionPadding={10}
                    sideOffset={5}
                    {...props}
                    forceMount
                    className={tooltipVariants({ ...props, color })}
                >
                    {children}
                    <TooltipPrimitive.Arrow
                        className={arrowVariants({ color })}
                        width={12}
                        height={6}
                    />
                </TooltipPrimitive.Content>
            </Transition>
        </TooltipPrimitive.Portal>
    );
}
